export default "__VITE_ASSET__BnLR28CW__"